window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.pokerBonusPobjedniciRepo = function () {

    var url = 'api/pokerbonuspobjednici';

    var list = function (bonusSifra, nadimak) {


        return fetch(url + casino.repos.base.serializeGetParams({
                sifra: bonusSifra,
                nadimak: nadimak || ''
            }))
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

    };

    return {
        list: list
    }

}();